import React from 'react';
import { Box, BoxProps } from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system/system';

export const renderCardLabelledValue = (
  label: string,
  value?: string,
  boxProps?: BoxProps,
  nowrap?: boolean
): React.ReactElement => (
  <Box {...(boxProps || {})}>
    <strong>{label}:</strong>{' '}
    <tqc.span whiteSpace={nowrap ? 'nowrap' : 'unset'}>{value}</tqc.span>
  </Box>
);
